<div class="card-container">
  <div nxRow>
    <div nxCol="12,12,6,6">
      <span class="card-title lbl">{{ data?.campaignName }}</span>
    </div>
    <div nxCol="12,12,6,6" class="">
      <p class="badge-padding">
        <nx-badge
          class="badge-text"
          [ngClass]="{
            'badge-color-motor': data.category === 'Motor',
            'badge-color-others': data.category === 'Others',
            'badge-color-plines': data.category === 'Non-motor Plines',
            'badge-color-non-motor': data.category === 'Non-motor Commercial',
          }"
          >{{ data?.category }}</nx-badge
        >
      </p>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3,3,4,2" class="detail-title">
      <p>Period</p>
    </div>
    <div nxCol="9,9,8,10" class="detail-desc">
      {{ formatDate(data?.startDate, "MMM YYYY") }} -
      {{ formatDate(data?.endDate, "MMM YYYY") }}
    </div>
    <div nxCol="3,3,4,2" class="detail-title">
      <p>Criteria</p>
    </div>
    <div nxCol="5,4,4,6" class="detail-desc">
      {{ data?.criteria }}
    </div>
    @if (!(previewCampaign$ | async)?.isLoading) {
      <div nxCol="4,5,4,4" class="detail-desc std-ta-right">
        as at {{ (previewAsDate$ | async)?.month }}
        {{ (previewAsDate$ | async)?.year }}
      </div>
    }
  </div>

  @if (!(previewCampaign$ | async)?.isLoading) {
    <div class="preview-body-container">
      <div>
        @for (details of groupListing$ | async; track details) {
          <div nxRow class="campaign-details">
            <div nxCol="12">
              <p class="sub-details-title">
                {{ details.groupName }}
              </p>
            </div>
            @for (subDetails of details.subgroupList; track subDetails) {
              <div
                class="details-column"
                [ngClass]="{ 'no-border': details.subgroupList.length <= 1 }"
                nxCol="6,6,4,4"
              >
                <div
                  class="details-border-right"
                  [ngClass]="{ 'no-border': details.subgroupList.length <= 1 }"
                >
                  <span class="sub-details-text">{{
                    subDetails.subgroupName
                  }}</span>
                  <p
                    class="sub-details-value"
                    [ngClass]="
                      identifyMomVariance(
                        subDetails.subgroupValue,
                        subDetails.subgroupName
                      )
                    "
                  >
                    {{ subDetails.subgroupValue }}
                  </p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if ((previewCampaign$ | async)?.isLoading) {
    <div nxRow class="loading-container">
      <div nxCol="12" class="std-ta-center loading">
        <nx-spinner size="large"></nx-spinner>
      </div>
    </div>
  }
</div>
